import { AdminDashboard } from '../components/AdminDashboard';

export function AdminPage() {
  return <AdminDashboard />;
}